import { format } from 'date-fns'
import { UnwrappedButton } from '@opallabs/kuiper'
import {
  popover,
  popoverText,
  popoverDateTitle,
  popoverDate,
  popoverHr,
} from './styles'

const DATE_FORMAT_SHORT = 'MMM d, yyyy'
const DATE_FORMAT_LONG = 'MMM d, yyyy h:mm aaa'

export type ContentLiveDateDialogueProps = { dueDate: Date }
export const ContentLiveDateDialogue: React.FC<
  ContentLiveDateDialogueProps
> = ({ dueDate }) => (
  <div css={popover}>
    <span css={popoverText}>
      This phase hasn&apos;t been given a specific due date.
    </span>
    <span css={popoverDateTitle(true)}>Content Scheduled Date</span>
    <span css={popoverDate}>{format(dueDate, DATE_FORMAT_SHORT)}</span>
  </div>
)

export type DueDateDialogueProps = { dueDate: Date; contentLiveDate: Date }
export const DueDateDialogue: React.FC<DueDateDialogueProps> = ({
  dueDate,
  contentLiveDate,
}) => {
  // contentLiveData may be invalid for unscheduled objects
  const isContentLiveDateValid = !isNaN(contentLiveDate.getTime())

  return (
    <div css={popover}>
      <span css={popoverDateTitle()}>Due Date</span>
      <span css={popoverDate}>{format(dueDate, DATE_FORMAT_SHORT)}</span>
      {isContentLiveDateValid && (
        <>
          <span css={popoverDateTitle()}>Content Scheduled Date</span>
          <span css={popoverDate}>
            {format(contentLiveDate, DATE_FORMAT_SHORT)}
          </span>
        </>
      )}
    </div>
  )
}

export type UndoOwnDialogueProps = {
  completedAt: Date
  toggleTaskCompletion: (value: boolean) => void
}
export const UndoOwnDialogue: React.FC<UndoOwnDialogueProps> = ({
  completedAt,
  toggleTaskCompletion,
}) => (
  <div css={popover}>
    <UnwrappedButton
      color="blue"
      label="Undo"
      type="invisible"
      onClick={() => toggleTaskCompletion(false)}
    />
    <div css={popoverHr} />
    <span css={popoverText}>You completed this task</span>
    <span css={popoverDate}>{format(completedAt, DATE_FORMAT_LONG)}</span>
  </div>
)

export const StageCompleteDialogue: React.FC = () => (
  <div css={popover}>
    <span css={popoverText}>
      This task is in a completed phase. Only tasks in the current phase can be
      undone.
    </span>
  </div>
)

export const FutureStageDialogue: React.FC = () => (
  <div css={popover}>
    <div css={popoverText}>
      This task is in a future phase. Only tasks from the current phase can be
      completed.
    </div>
  </div>
)
